import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const QrcodesReportViewModule = new Module({
  id: 'QRCODES-REPORT:VIEW:*',
  name: 'QR Codes Report',
  label: 'QR Codes Report',
  path: 'qrcodes-report',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/QrcodesReport'))
  )
});

const QrcodesReportModules = [QrcodesReportViewModule];

export default new ModuleBundle(
  'QrcodesReport',
  QrcodesReportModules
);
